export const CATEGORY_LABELS_BY_CODE = {
    8: "Make Up 400",
    9: "Munich",
    10: "Copenhague",
    11: "Miami-Splau",
};

const CATEGORY_LABELS_BY_NAME = {
    "make up 400": "Make Up 400",
    makeup400: "Make Up 400",
    munich: "Munich",
    copenhague: "Copenhague",
    miami: "Miami-Splau",
    "miami-splau": "Miami-Splau",
};

export const normalizeCategoryLabel = (category) => {
    if (category === null || category === undefined) return "";

    const value = String(category).trim();
    if (!value) return "";

    const numericValue = Number(value);
    if (Number.isInteger(numericValue) && CATEGORY_LABELS_BY_CODE[numericValue]) {
        return CATEGORY_LABELS_BY_CODE[numericValue];
    }

    return CATEGORY_LABELS_BY_NAME[value.toLowerCase()] || value;
};

export const formatCategories = (categories) => {
    if (!categories) return "";

    const categoryList = Array.isArray(categories)
        ? categories
        : String(categories).split(",");

    return categoryList
        .map(normalizeCategoryLabel)
        .filter(Boolean)
        .join(", ");
};
